import m from 'mithril';

export interface ButtonAttrs {
    class?: string;
    variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
    size?: 'sm' | 'md' | 'lg' | 'icon';
    icon?: string;
    loading?: boolean;
    [key: string]: any;
}

const BASE = 'hover-spring !inline-flex !items-center !justify-center !gap-2 !font-bold !rounded-lg !border-0 !outline-none !cursor-pointer !select-none !leading-none !no-underline disabled:!opacity-50 disabled:!cursor-not-allowed active:!scale-95';

const VARIANTS: Record<string, string> = {
    primary:   '!bg-gradient-to-r !from-[var(--color-primary)] !to-[var(--color-secondary)] !text-white hover:!shadow-[0_0_20px_var(--color-primary-glow)] !shadow-md hover:!brightness-110 !transition-all',
    secondary: '!bg-[var(--color-surface)] !text-[var(--color-text-base)] !border !border-[var(--color-border)] hover:!bg-[var(--color-border)] hover:!shadow-[0_0_15px_rgba(0,0,0,0.1)] !transition-all',
    outline:   '!bg-transparent !border-2 !border-solid !border-[var(--color-border)] !text-[var(--color-text-base)] hover:!border-[var(--color-primary)] hover:!text-[var(--color-primary)] hover:!shadow-[0_0_15px_var(--color-primary-glow)] !transition-all',
    ghost:     '!bg-transparent !text-[var(--color-text-base)] hover:!bg-[var(--color-surface)] hover:!shadow-sm !transition-all',
    danger:    '!bg-gradient-to-r !from-red-500 !to-rose-600 !text-white hover:!shadow-[0_0_20px_rgba(239,68,68,0.4)] !shadow-md hover:!brightness-110 !transition-all',
};

const SIZES: Record<string, string> = {
    sm:   '!text-xs !py-1.5 !px-3 !m-0',
    md:   '!text-sm !py-2 !px-5 !m-0',
    lg:   '!text-base !py-2.5 !px-7 !m-0',
    icon: '!p-2 !m-0 !aspect-square',
};

export const Button: m.Component<ButtonAttrs> = {
    view: ({ attrs: { class: c = '', variant = 'primary', size = 'md', icon, loading, ...rest }, children }) =>
        m('button', {
            class: `${BASE} ${VARIANTS[variant]} ${SIZES[size]} ${c}`,
            disabled: loading || rest.disabled,
            ...rest,
        }, [
            loading && m('iconify-icon', { icon: 'lucide:loader-2', class: '!animate-spin' }),
            !loading && icon && m('iconify-icon', { icon, class: '!text-[1.1em]' }),
            children,
        ])
};
